import React from 'react';
import { Select } from '../../../../../../ui/Select/Select';
import { useAppSelector } from '../../../../../../app/hooks';
import { IRegisterForm } from '../../../../../../interface/Auth/frontend';
import { CitizenshipIdEnum } from '../../../../../../enum/auth';
import { RuPassportNumberBlock } from './RuPassportBlock';
import { ForeignPassportBlock } from './ForeignPassportBlock';
import { RegFormCaption } from '../../../../../../components/Font';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

interface IProps {
	registerForm: IRegisterForm;
	setRegisterForm(value: IRegisterForm): void;
}
export const PassportContainer: React.FC<IProps> = ({ registerForm, setRegisterForm }) => {
	const { identityCardTypes, isFetching } = useAppSelector(state => state.account);

	const { t } = useTranslation();
	const Theme = useTheme();

	return (
		<>
			<RegFormCaption color={Theme.color.secondary}>
				{t('passport.registrationForm.citizenshipSelect.title')}
			</RegFormCaption>

			<Select
				data={identityCardTypes}
				selectedValue={registerForm.citizenshipId}
				onSelect={id => setRegisterForm({ ...registerForm, citizenshipId: id })}
			/>

			{registerForm.citizenshipId === CitizenshipIdEnum.Russian && !isFetching && (
				<RuPassportNumberBlock registerForm={registerForm} setRegisterForm={setRegisterForm} />
			)}

			{registerForm.citizenshipId === CitizenshipIdEnum.Foreign && (
				<ForeignPassportBlock registerForm={registerForm} setRegisterForm={setRegisterForm} />
			)}
		</>
	);
};
